import { render, staticRenderFns } from "./ModalBarem.vue?vue&type=template&id=5ab6e77a&scoped=true"
import script from "./ModalBarem.vue?vue&type=script&lang=js"
export * from "./ModalBarem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab6e77a",
  null
  
)

export default component.exports